import { useTenantProfile } from 'hooks/api/tenant/useTenantProfile'
import Icon from 'components/common/Icon'
import Text from 'components/common/Text'
import colors from 'utility/colors'

export const TagBlock = ({ children }) => {
	const { data: tenantProfile } = useTenantProfile()
	const secondaryColor = tenantProfile?.theme?.secondaryColor

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				gap: 10,
				background: colors.WHITE,
				borderRadius: 3,
				padding: 25,
			}}
		>
			<Icon icon='check-circle' solid size={20} color={secondaryColor} />

			<Text
				color={secondaryColor}
				size={16}
				style={{ fontWeight: 'bold', marginBottom: 0, paddingBottom: 0 }}
			>
				{children}
			</Text>
		</div>
	)
}
